var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppliance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9H15M1 9V1.6C1 1.44087 1.06321 1.28826 1.17574 1.17574C1.28826 1.06321 1.44087 1 1.6 1H14.4C14.5591 1 14.7117 1.06321 14.8243 1.17574C14.9368 1.28826 15 1.44087 15 1.6V9H1ZM1 9V20.4C1 20.4788 1.01552 20.5568 1.04567 20.6296C1.07583 20.7024 1.12002 20.7685 1.17574 20.8243C1.23145 20.88 1.29759 20.9242 1.37039 20.9543C1.44319 20.9845 1.52121 21 1.6 21H14.4C14.4788 21 14.5568 20.9845 14.6296 20.9543C14.7024 20.9242 14.7685 20.88 14.8243 20.8243C14.88 20.7685 14.9242 20.7024 14.9543 20.6296C14.9845 20.5568 15 20.4788 15 20.4V9H1Z",
    stroke: "#467B3E",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppliance);
export default __webpack_public_path__ + "static/media/appliance.29d0f9fbd93c518a1ac9eb84fd407567.svg";
export { ForwardRef as ReactComponent };